import { tss } from "tss-react";
import { viewsHeaderHeight, defaultBorder } from "./common";

const useStyles = tss.create((theme: any) => ({
    root: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        verticalAlign: "top",
        //marginLeft: 30,
        boxShadow : 'none'
    },
    topHeader: {
        position: "relative",
        flexDirection: "row",
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 20,
        width: "100%",
        height: viewsHeaderHeight,
        margin: "0 0 30px 0",
        boxShadow : 'none',
        justifyContent: "space-between"
    },
    content: {
        //backgroundColor: "#f7f7f7", //side panel color
        height: "calc(100% - " + viewsHeaderHeight + "px)",
        display: "inline-flex",
        width: "100%",
    },
    main: {
        width: "100%", //"calc(100% - 320px)",
        height: "100%",
        maxWidth: "100%",
        //borderRight: defaultBorder,
        //backgroundColor: "#e3e3e3", //bottom panel color
        overflow: "hidden",
        display: "inline-block",
        position: "relative",
    },
    side: {
        width: 200,
        minWidth: 250,
        maxWidth: 250,
        height: "100%",
        display: "inline-block",
        float: "right",
        marginLeft: '24px'
    },
}));
export default useStyles;
